import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import { parseDate } from 'utils/Appointments';

import KDSSelectDateRange from '@decisiv/ui-components/lib/components/SelectDateRange';
import { isEmpty } from 'lodash';

/* istanbul ignore next -- @preserve */
const changeHandler = (onChange) => (dates) =>
  dates ? onChange(dates.map((date) => date.toISOString())) : onChange([]);

/* istanbul ignore next -- @preserve */
const makeValues = (value) =>
  isEmpty(value) ? undefined : value?.map((date) => parseDate(date));

const SelectDateRange = ({ name, defaultValue, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSSelectDateRange
          values={makeValues(value)}
          onChange={changeHandler(onChange)}
          warningMessage={errors[name]?.message?.toString()}
          {...props}
        />
      )}
    />
  );
};

SelectDateRange.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.bool,
  ]),
};

SelectDateRange.defaultProps = {
  defaultValue: undefined,
};

export default SelectDateRange;
